import { post, patch, get, destroy } from './httpClient'

export const createCustomer = (body) => post('/customer/create', body)
export const resetPassword = (id, body) => patch('/customer/update/' + id, body)
export const getCustomers = (query) => get('/customer', query)
export const getCustomerTypes = (query) => get('/customer/type', query)
export const addCustomerType = (body) => post('/customer/type/create', body)
export const deleteCustomer = (ids) => destroy('/customer/delete', { customer_id: ids })
